import { TOTAL_PRICE_HEAD_GROUP } from "@/domains/components/totalPrice/constants";
import { useGetGuide, type RefundRoomInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Center, Flex, Spinner, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { Carousel } from "react-responsive-carousel";
import { CustomCenter, CustomRoom, CustomTable, CustomText, CustomTitle } from "./totalPrice.style";

export const TotalPrice = () => {
    const { data } = useGetGuide<RefundRoomInfoResponse>({ section: "prices" });
    const { isTablet, isMobile } = MEDIA();

    return data ? (
        <Center as="section" flexDir="column" rowGap={isTablet ? "32px" : "64px"}>
            <Center flexDir="column">
                <CustomTitle fontFamily="Cormorant">Accommodations Price</CustomTitle>
                <Text fontFamily="Cormorant">객실 요금</Text>
            </Center>
            <Center w="100%" alignItems="baseline" flexDir="column" rowGap="8px">
                <CustomTable>
                    <Thead>
                        <Tr>
                            {TOTAL_PRICE_HEAD_GROUP.map((head, headIdx) => (
                                <Th key={head.idx}>
                                    {isMobile && headIdx === 4 ? head.title.split("/")[0] : head.title}
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                </CustomTable>
                <CustomCenter>
                    <Carousel width="100%" showIndicators={false} showStatus={false} showThumbs={false} emulateTouch>
                        {data.currentRooms.map((currentRoom) => {
                            const { roomDetailInfo, seasons } = currentRoom;

                            return (
                                <Center key={currentRoom.roomIdx} w="100%" h="100%" cursor="pointer">
                                    <CustomRoom.TITLE>{roomDetailInfo.name}</CustomRoom.TITLE>
                                    <Flex w="80%" flexDir="column">
                                        {seasons.map((season) => {
                                            const { friday, weekday, weekend } = season.prices;
                                            return (
                                                <CustomRoom.SEASON key={season.name}>
                                                    <Text>{season.name}</Text>
                                                    <Text>{Number(weekday).toLocaleString()}</Text>
                                                    <Text>{Number(friday).toLocaleString()}</Text>
                                                    <Text>{Number(weekend).toLocaleString()}</Text>
                                                </CustomRoom.SEASON>
                                            );
                                        })}
                                    </Flex>
                                </Center>
                            );
                        })}
                    </Carousel>
                </CustomCenter>
            </Center>
            <CustomText w="100%" textAlign="center">
                * 객실별 전체 요금 테이블 입니다. 요금 테이블을 오른쪽으로 넘겨 보세요.
            </CustomText>
        </Center>
    ) : (
        <Spinner />
    );
};
